<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="back()">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container">
  <div style="text-align: end;" *ngIf="addon?.isSingleItem"><h2 class="total">{{"ADDONS.TOTAL" | translate}} <span>{{totalAmount | number:'1.2-2'}} $</span></h2> </div>
  <h2>{{addon?.i18nName[translate.currentLang.toUpperCase()]}}</h2>
  <img [src]="addon?.imgUrl" alt="">
  <p class="description">{{addon?.i18nDescription[translate.currentLang.toUpperCase()]}}</p>
  <p class="price">{{addon?.price +' '+addon?.currency}}</p>
  <p class="price old-price" *ngIf="addon?.oldPrice && addon?.oldPrice !== ''">
    {{addon?.oldPrice +' '+addon?.currency}}
    <span class="bar-override"></span>
  </p>
  <div class="amount" *ngIf="addon?.isSingleItem">
    <mat-icon svgIcon="mat:do_not_disturb_on" [class.btn-disabled]="addon?.quantity.count === 0"
      (click)="addQuantity(addon, 'minus')"></mat-icon>
    <span class="count">
      {{addon?.quantity.count}}
    </span>
    <mat-icon svgIcon="mat:add_circle" [class.btn-disabled]="addon?.quantity.count === addon?.quantity.max"
      (click)="addQuantity(addon, 'plus')"></mat-icon>
  </div>
</div>
<div class="footer-position" *ngIf="addon?.isSingleItem">
  <button class="its-button" *ngIf="!purchaseSpinner" (click)="openModalConfirmPurchase(addon)">{{"ADDONS.BUY" |
    translate}}</button>
  <button class="its-button" *ngIf="purchaseSpinner">
    <ion-spinner name="crescent" style="height: 17px;"></ion-spinner>
  </button>
</div>
